module.exports = __webpack_public_path__ + "img/btn-left.f055f549.svg";